import React, { useEffect, useState } from "react";
import { Application } from "@/api/applications";
import RigthPanel from "@/ui-controls/RigthPanel";
import UpdateApplicationForm from "@/components/applications/UpdateApplicationForm";

interface Props {
  application: Application;
  onUpdate: (application: Application) => any;
  onClose: () => any;
}

const UpdateApplication = (props: Props) => {
  useEffect(() => {
    setIPanelOpen(props.application !== undefined);
  }, [props.application]);

  const onCloseUpdateAppPanel = () => {
    setIPanelOpen(false);
    if (props.onClose) props.onClose();
  };

  const [isPanelOpen, setIPanelOpen] = useState<boolean>(false);

  return (
    <>
      <RigthPanel
        header="Edit Application"
        isOpen={isPanelOpen}
        dismissPanel={onCloseUpdateAppPanel}
        childComponent={UpdateApplicationForm}
        childProps={{
          application: props.application,
          onClose: () => onCloseUpdateAppPanel(),
          onSave: (app: Application) => {
            props.onUpdate(app);
            onCloseUpdateAppPanel();
          },
        }}
      ></RigthPanel>
    </>
  );
};

export default UpdateApplication;
